import {
  LIST_CUSTOMER_URL,
  LIST_INVOICE_URL,
  LOGIN_URL,
  SELECT_INVOICE_URL,
  SELECT_COUPONS_URL,
  LOCATION_CODE_LISTING_URL,
} from "../../utils/APIEndpoints";
import {
  LOGIN_LOADING,
  LOGIN_SUCCESS,
  LOGIN_ERROR,
  INVOICE_LISTING_LOADING,
  INVOICE_LISTING_SUCCESS,
  INVOICE_LISTING_ERROR,
  INVOICE_DETAIL_LOADING,
  INVOICE_DETAIL_SUCCESS,
  INVOICE_DETAIL_ERROR,
  CUSTOMER_LISTING_LOADING,
  CUSTOMER_LISTING_SUCCESS,
  CUSTOMER_LISTING_ERROR,
  COUPON_DETAIL_LOADING,
  COUPON_DETAIL_SUCCESS,
  COUPON_DETAIL_ERROR,
  LOCATION_CODE_LISTING_LOADING,
  LOCATION_CODE_LISTING_SUCCESS,
} from "./ActionTypes";
import {
  ADMIN_DASHBOARD_PATH,
  DASHBOARD_PATH,
  PASSWORDUPDATE_PATH,
} from "../../utils/AppRoutes";
import Axios from "axios";
import Swal from "sweetalert2";
import {
  getAlertToast,
  fixedTwoDigitsFloatValue,
} from "../../utils/functions/CustomFunctions";
import {
  LOCALSTORAGE_AUTH_TOKEN,
  LOCALSTORAGE_AUTH_USER,
} from "../../utils/constants/LocalStorage";
import { authHeader } from "../../utils/functions/CoreFunctions";
import API from "./API";
//Login Authentication
export function login(formData, history) {
  return (dispatch) => {
    dispatch({
      type: LOGIN_LOADING,
      payload: "",
    });
    Axios.post(LOGIN_URL, formData)
      .then((response) => {
        const { status, message: resMessage } = response.data;
        if (status === "Success") {
          let {
            userId,
            role,
            agencyId,
            firstName,
            lastName,
            profileImage,
            isFirstTimeLogin,
            email,
          } = response.data;
          let { accesstoken } = response.headers;
          let loggedUserData = {
            userId,
            role,
            agencyId,
            firstName,
            lastName,
            profileImage,
            email,
          };

          localStorage.setItem(LOCALSTORAGE_AUTH_TOKEN, accesstoken);
          localStorage.setItem(
            LOCALSTORAGE_AUTH_USER,
            JSON.stringify(loggedUserData)
          );
          Swal.fire(
            getAlertToast("success", "You have successfully signed in")
          );
          if (isFirstTimeLogin) {
            history.push(PASSWORDUPDATE_PATH);
          } else {
            if (formData.isAdminLogin === 1) {
                 history.push(ADMIN_DASHBOARD_PATH);
            } else {
              history.push(DASHBOARD_PATH);
              // history.push(
              //   role == "PayGov Admin" ? ADMIN_DASHBOARD_PATH : DASHBOARD_PATH
              // );
            }
          }
          dispatch({
            type: LOGIN_SUCCESS,
            payload: loggedUserData,
          });
        } else {
          Swal.fire(getAlertToast("error", resMessage));
        }
      })
      .catch((error) => {
        if (error.response) {
          let { data } = error.response;
          Swal.fire(getAlertToast("error", data.message));
          dispatch({
            type: LOGIN_ERROR,
            payload: data.message,
          });
        }
      });
  };
}

//Invoice List
export function getInvoiceList(paramsData) {
  return (dispatch) => {
    dispatch({
      type: INVOICE_LISTING_LOADING,
    });
    const options = {
      method: "GET",
      url: LIST_INVOICE_URL,
      headers: authHeader(),
      params: { ...paramsData },
    };
    API(options)
      .then((response) => {
        const { status } = response.data;
        if (status === "Success") {
          let initialData = response.data.data;
          initialData.forEach((element) => {
            element.paymentAmount = `$${fixedTwoDigitsFloatValue(
              element.paymentAmount
            )}`;
            return element;
          });
          dispatch({
            type: INVOICE_LISTING_SUCCESS,
            payload: initialData,
            totalCount: response.data.totalCount,
          });
        }
      })
      .catch((error) => {
        if (error.response) {
          let { data } = error.response;
          dispatch({
            type: INVOICE_LISTING_ERROR,
            payload: data.message,
          });
        }
      });
  };
}

//Invoice Detail
export function getInvoiceDetails(id) {
  return (dispatch) => {
    dispatch({
      type: INVOICE_DETAIL_LOADING,
    });
    const options = {
      method: "GET",
      url: SELECT_INVOICE_URL,
      headers: authHeader(),
      params: { invoiceMasterId: id },
    };
    API(options)
      .then((response) => {
        const { status } = response.data;
        if (status === "Success") {
          dispatch({
            type: INVOICE_DETAIL_SUCCESS,
            payload: response.data.data,
          });
        }
      })
      .catch((error) => {
        if (error.response) {
          let { data } = error.response;
          dispatch({
            type: INVOICE_DETAIL_ERROR,
            payload: data.message,
          });
        }
      });
  };
}

//Coupon List

export function getCouponDetails(id) {
  return (dispatch) => {
    dispatch({
      type: COUPON_DETAIL_LOADING,
    });

    const options = {
      method: "GET",
      url: SELECT_COUPONS_URL,
      headers: authHeader(),
      params: { couponId: parseInt(id) },
    };

    API(options)
      .then((response) => {
        const { status } = response.data;
        if (status === "Success") {
          dispatch({
            type: COUPON_DETAIL_SUCCESS,
            payload: response.data.data,
          });
        }
      })
      .catch((error) => {
        if (error.response) {
          let { data } = error.response;
          dispatch({
            type: COUPON_DETAIL_ERROR,
            payload: data.message,
          });
        }
      });
  };
}

//Customer List
export function listCustomer(paramsData) {
  return (dispatch) => {
    dispatch({
      type: CUSTOMER_LISTING_LOADING,
    });
    const options = {
      method: "GET",
      url: LIST_CUSTOMER_URL,
      headers: authHeader(),
      params: { ...paramsData },
    };
    API(options)
      .then((response) => {
        const { status } = response.data;
        if (status === "Success") {
          dispatch({
            type: CUSTOMER_LISTING_SUCCESS,
            payload: response.data.data,
            totalCount: response.data.totalCount,
          });
        }
      })
      .catch((error) => {
        if (error.response) {
          let { data } = error.response;
          dispatch({
            type: CUSTOMER_LISTING_ERROR,
            payload: data.message,
          });
        }
      });
  };
}

//Location Code
export function getLocationCodeList(paramsData) {
  return (dispatch) => {
    dispatch({
      type: LOCATION_CODE_LISTING_LOADING,
    });
    const options = {
      method: "GET",
      url: LOCATION_CODE_LISTING_URL,
      headers: authHeader(),
      params: { ...paramsData },
    };
    API(options)
      .then((response) => {
        const { status } = response.data;
        if (status === "Success") {
          let initialData = response.data.data;
          dispatch({
            type: LOCATION_CODE_LISTING_SUCCESS,
            payload: initialData,
          });
        }
      })
      .catch((error) => {
        if (error.response) {
          let { data } = error.response;
        }
      });
  };
}
